import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export function useSendText() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async ({
      phone_number,
      body,
      contact_name,
      attachments,
      chat_id,
      chat_type,
      chat_title,
      participants,
    }: {
      phone_number: string;
      body: string;
      contact_name?: string | null;
      attachments?: { url: string; mime_type: string; name: string; size: number }[];
      chat_id?: string;
      chat_type?: "individual" | "group";
      chat_title?: string | null;
      participants?: { phone: string; name?: string | null }[] | null;
    }) => {
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase.functions.invoke("send-text", {
        body: {
          phone_number,
          body,
          contact_name,
          attachments,
          chat_id,
          chat_type,
          chat_title,
          participants,
        },
      });

      if (error) throw error;
      if (data?.error) throw new Error(data.error);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["text-conversations"] });
      queryClient.invalidateQueries({ queryKey: ["text-conversation"] });
    },
  });
}
